import React from 'react';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import './Navigation.css';
import logo from '../../images/logo.png';
import { BsFacebook, BsLinkedin, BsTwitter, BsGithub } from "react-icons/bs";
import { Link } from 'react-router-dom';

const Navigation = () => {
    return (
        <>
            <Navbar collapseOnSelect expand="lg">
                <Container>
                    <Navbar.Brand href="#home">
                        <img width="100px"
                            height="70px"
                            className="rounded-pill"
                            src={logo} alt="logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="#Home">
                                <Link to="/home">Home</Link>
                            </Nav.Link>
                            <Nav.Link href="#About">About</Nav.Link>
                            <Nav.Link href="#Service">Service</Nav.Link>
                            <Nav.Link href="#Portfolio">Portfolio</Nav.Link>
                            <Nav.Link href="#Blog">
                                <Link to="/blog">Blog</Link>
                            </Nav.Link>
                            <Nav.Link href="#Contact">Contact
                                {/* <Link to="/home">Contact</Link> */}
                            </Nav.Link>
                        </Nav>
                        <Nav>
                            <Nav.Link
                                href="https://www.linkedin.com/in/nasirul866/" target="_blank"
                                className="icon ms-2"><BsLinkedin />
                            </Nav.Link>
                            <Nav.Link
                                href="https://github.com/Nasirul-Islam" target="_blank"
                                className="icon ms-2"><BsGithub />
                            </Nav.Link>
                            <Nav.Link
                                href="https://www.facebook.com/ni866" target="_blank"
                                className="icon ms-2"><BsFacebook />
                            </Nav.Link>
                            <Nav.Link
                                href="https://twitter.com/Nasirul75803645" target="_blank"
                                className="icon ms-2"><BsTwitter />
                            </Nav.Link>
                            <Nav.Link
                                href="https://drive.google.com/file/d/1iqw-B24UB7-9fLZZnKr3wBuuoc6wTohp/view?usp=sharing" target="_blank"
                                className="ms-2">
                                <Button variant="outline-info">
                                    Download Resume
                                </Button>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default Navigation;